import React, { Component } from 'react'
import styled from 'styled-components'
import R from 'ramda'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { TextInput, Button, Select } from 'advenio-components'
import { Form } from 'formsy-react-2' //eslint-disable-line
import { Col } from 'react-flexbox-grid'

import LoadingSpinner from '../../Components/LoadingSpinner'
import ContractsActions from '../../Data/Redux/ContractsRedux'
import EnrollActions from '../../Data/Redux/EnrollRedux'
import ReservedActions from '../../Data/Redux/ReservedRedux'
import ReEnrollActions from '../../Data/Redux/ReEnrollRedux'
import ReEnrollFromDisenrollmentsActions from '../../Data/Redux/ReEnrollFromDisenrollmentsRedux'
import PaymentTypesActions from '../../Data/Redux/PaymentTypesRedux'
import CountriesActions from '../../Data/Redux/CountriesRedux'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 96%;
  padding: 16px;
`
const Div = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  &:last-of-type {
    justify-content: flex-end;
  }
`

const initialSelectObj = [{
  id: 0,
  value: 0,
  label: '',
}]

let rooms = initialSelectObj
let studyPrograms = initialSelectObj
let parents = initialSelectObj
let contracts = initialSelectObj
let services = initialSelectObj
let payment_types = initialSelectObj

class ReinscriptionModal extends Component {
  constructor(props) {
    super(props)
    rooms = R.clone(this.props.classrooms)
    for (let i = 0; i < rooms.length; i += 1) {
      rooms[i].label = rooms[i].name
      rooms[i].value = rooms[i].id
      rooms[i].id = rooms[i].id
    }
    studyPrograms = R.clone(this.props.studyPrograms)
    for (let i = 0; i < studyPrograms.length; i += 1) {
      studyPrograms[i].label = studyPrograms[i].name
      studyPrograms[i].value = studyPrograms[i].id
      studyPrograms[i].id = studyPrograms[i].id
    }
    parents = R.clone(this.props.parents)
    for (let i = 0; i < parents.length; i += 1) {
      parents[i].label = parents[i].full_name
      parents[i].value = parents[i].id
      parents[i].id = parents[i].id
    }

    const classrooms = rooms.filter(room => room.type !== 'Sick Room')

    const [activeClassroomid] = rooms.filter (rooms => rooms.id === this.props.activeClassroomid)
    this.state = {
      classrooms,
      studyPrograms,
      activeClassroomid:activeClassroomid!== undefined ? activeClassroomid.id: this.props.type === 'enroll' ? 0 : null,
      companies: [{ id: 0, label: 'N/A', value: 0 }],
      productFromParent: false,
      parents,
      selectedCompany: 0,
      parentCompany: null,
      contracts: initialSelectObj,
      payment_types: initialSelectObj,
      services: initialSelectObj,
      emptyContracts: false,
      symbol: null,
      code: null,
    }
  }

  componentWillMount = () => {
    if (this.state.parents) {
      this.props.getParentContracts(this.state.parents[0].id)
    }
    this.props.getCountries()
    this.props.getPaymentTypes()
  }

  componentWillReceiveProps = (nextProps) => {
    const newState = { ...this.state }
    if (nextProps.countries && nextProps.user) {
      const country = nextProps.countries.find(c => c.id === nextProps.user.country_id)
      if (country) {
        newState.symbol = country.currency_symbol
        newState.code = country.currency_code
      }
    }
    if (nextProps.contracts) {
      if (nextProps.contracts.length > 0) {
        contracts = R.clone(nextProps.contracts)
        for (let i = 0; i < contracts.length; i += 1) {
          contracts[i].label = contracts[i].name
          contracts[i].value = contracts[i].id
          contracts[i].id = contracts[i].id
        }
        services = R.clone(contracts[0].products)
        for (let i = 0; i < services.length; i += 1) {
          services[i].label = services[i].product
          services[i].value = services[i].contract_product_id
          services[i].id = services[i].contract_product_id
        }
        newState.services = services
        newState.contracts = contracts
        newState.productFromParent = true
        this.setState(newState)
      } else {
        services = R.clone(this.props.products)
        for (let i = 0; i < services.length; i += 1) {
          services[i].label = services[i].name
          services[i].value = services[i].id
          services[i].id = services[i].id
        }
        newState.services = services
        newState.productFromParent = false
        this.setState(newState)
      }
    }
    if (nextProps.payment_types) {
      payment_types = R.clone(nextProps.payment_types)
      for (let i = 0; i < payment_types.length; i += 1) {
        payment_types[i].label = payment_types[i].name
        payment_types[i].value = payment_types[i].id
        payment_types[i].id = payment_types[i].id
      }
      newState.payment_types = payment_types
      if (payment_types.length === 0) {
        newState.payment_types = initialSelectObj
      }
      this.setState(newState)
    }
    if (nextProps.company_contracts.length > 0) {
      contracts = R.clone(nextProps.company_contracts)
      for (let i = 0; i < contracts.length; i += 1) {
        contracts[i].label = contracts[i].name
        contracts[i].value = contracts[i].id
        contracts[i].id = contracts[i].id
      }
      services = R.clone(contracts[0].products)
      for (let i = 0; i < services.length; i += 1) {
        services[i].label = services[i].product_name
        services[i].value = services[i].id
        services[i].id = services[i].id
      }
      newState.services = services
      newState.contracts = contracts
      newState.productFromParent = true
      this.setState(newState)
    }
    if (nextProps.companies.length > 0) {
      if (nextProps.parents[0].company_id) {
        const parentCompany =
        nextProps.companies.find(company => company.id === nextProps.parents[0].company_id)
        if (parentCompany) {
          this.setState({ parentCompany: parentCompany.id })
        }
      }
      const companies = R.clone(nextProps.companies)
      const allCompanies = companies.map(company => ({
        ...company,
        label: company.name,
        value: company.id,
        id: company.id,
      }))
      allCompanies.unshift({ id: 0, value: 0, label: 'Sin Empresa' })
      this.setState({ companies: allCompanies })
    }
  }

  onChange = (model) => {
    if (model.contrato !== 0) {
      const newState = { ...this.state }
      const [newContract] = newState.contracts.filter(contract => contract.id == model.contrato)
      if (!newContract) {
        return
      }
      for (let i = 0; i < newContract.products.length; i += 1) {
        if (newContract.products[i].product_name) {
          newContract.products[i].label = newContract.products[i].product_name
          newContract.products[i].value = newContract.products[i].id
          newContract.products[i].id = newContract.products[i].id
        } else {
          newContract.products[i].label = newContract.products[i].mame
          newContract.products[i].value = newContract.products[i].contract_product_id
          newContract.products[i].id = newContract.products[i].contract_product_id
        }
      }
      if (newContract.products.length > 0) {
        newState.services = newContract.products
      }
      this.setState(newState)
    }
    if (model.empresa == 0) {
      const newState = { ...this.state }
      services = R.clone(this.props.products)
      contracts = initialSelectObj
      for (let i = 0; i < services.length; i += 1) {
        services[i].label = services[i].name
        services[i].value = services[i].id
        services[i].id = services[i].id
      }
      newState.services = services
      newState.contracts = contracts
      newState.productFromParent = false
      newState.emptyContracts = true
      this.setState(newState)
    } else {
      this.setState({
        selectedCompany: model.empresa, emptyContracts: false, productFromParent: true })
      if (this.state.selectedCompany !== model.empresa) {
        this.handleSelect(Number(model.empresa))
      }
    }
  }

  onClick = (model) => {
    const { id, type } = this.props
    let params = ''
    if (type === 'enroll' || type === 'reserved') {
      if (this.state.productFromParent) {
        params = {
          classroom_id: model.classroom,
          study_program_id: model.programa,
          contract_product_id: model.servicio,
          paying_parent_id: model.tutor,
          enrollment_discount: model.descuento,
          payment_type_id: model.pago,
          tax_id: model.curp,
        }
      } else {
        params = {
          classroom_id: model.classroom,
          study_program_id: model.programa,
          center_product_id: model.servicio,
          paying_parent_id: model.tutor,
          enrollment_discount: model.descuento,
          payment_type_id: model.pago,
          tax_id: model.curp,
        }
      }
      if (type === 'enroll') {
        this.props.postEnroll(id, params)
      } else {
        this.props.postReserved(id, params)
      }
    } else {
      if (this.state.productFromParent) {
        params = {
          classroom_id: model.classroom,
          study_program_id: model.programa,
          contract_product_id: model.servicio,
          paying_parent_id: model.tutor,
          enrollment_discount: model.descuento,
          payment_type_id: model.pago,
          tax_id: model.curp,
        }
      } else {
        params = {
          classroom_id: model.classroom,
          study_program_id: model.programa,
          center_product_id: model.servicio,
          paying_parent_id: model.tutor,
          enrollment_discount: model.descuento,
          payment_type_id: model.pago,
          tax_id: model.curp,
        }
      }
      if (type === 'reenroll') {
        this.props.postReEnroll(id, params)
      } else {
        this.props.postReEnrollFromDisenrollments(id, params)
      }
    }
  }

  getButtonTitle = (type) => {
    switch (type) {
      case 'enroll':
        return 'Inscribir'
      case 'reserved':
        return 'Terminar inscripcion'
      case 'reenroll':
        return 'Reinscribir'
      case 'reenrollfromdisenroll':
        return 'Reinscribir'

      default:
        return null
    }
  }

  handleSelect = (option) => {
    if (option.id !== 0) {
      this.props.getCompanyContracts(option)
    }
  }

  render() {
    const { loading, type, loadingcontracts } = this.props
    const { classrooms: stateClassrooms, contracts: stateContracts, parents: stateParents,
      payment_types: statePaymentTypes, services: stateServices,
      studyPrograms: stateStudyPrograms, companies: stateCompanies,activeClassroomid } = this.state
    return (
      <Container>
        {(!loadingcontracts && stateServices.length > 0 && stateServices[0].label !== undefined ) ?
          <Form
            onChange={this.onChange}
            onSubmit={this.onClick}
          >
            <Div>
              <Col xs={4} sm={4} md={4} lg={4}>
                <Select
                  name="classroom"
                  label="Sala"
                  // value={(stateClassrooms.length > 0 && stateClassrooms[0].value) && stateClassrooms[0].value}
                  value={activeClassroomid}
                  options={stateClassrooms}
                />
              </Col>
              <Col xs={4} sm={4} md={4} lg={4}>
                <Select
                  name="programa"
                  label="Programa"
                  value={(stateStudyPrograms.length > 0 && stateStudyPrograms[0].value)
                    && stateStudyPrograms[0].value}
                  options={stateStudyPrograms}
                />
              </Col>
              <Col xs={4} sm={4} md={4} lg={4} >
                <TextInput
                  name="descuento"
                  value=""
                  prefix={this.state.symbol}
                  suffix={this.state.code}
                  type="number"
                  label={type === 'enroll' || type === 'reserved' ? 'Descuento inscripción' : 'Descuento reinscripción'}
                />
              </Col>
            </Div>
            <Div>
              <Col xs={4} sm={4} md={4} lg={4}>
                <Select
                  name="tutor"
                  label="Tutor a cargo"
                  value={(stateParents[0] && stateParents[0].value) && stateParents[0].value}
                  options={stateParents}
                />
              </Col>
              <Col xs={4} sm={4} md={4} lg={4}>
                <Select
                  name="empresa"
                  label="Empresas"
                  value={this.state.parentCompany}
                  options={stateCompanies}
                />
              </Col>
              <Col xs={4} sm={4} md={4} lg={4}>
                <Select
                  name="contrato"
                  label="Contrato"
                  disabled={this.state.emptyContracts}
                  value={(stateContracts[0] && stateContracts[0].value) && stateContracts[0].value}
                  options={stateContracts}
                />
              </Col>
            </Div>
            <Div>
              <Col xs={4} sm={4} md={4} lg={4}>
                <Select
                  name="servicio"
                  label="Tipo de servicio"
                  value={(stateServices[0] && stateServices[0].value) && stateServices[0].value}
                  options={stateServices}
                />
              </Col>
              <Col xs={4} sm={4} md={4} lg={4}>
                <Select
                  name="pago"
                  label="Forma de Pago"
                  value={(statePaymentTypes.length > 0 && statePaymentTypes[0].value)
                    && statePaymentTypes[0].value}
                  options={statePaymentTypes}
                />
              </Col>
              {this.props.needsCurp &&
                <Col xs={4} sm={4} md={4} lg={4}>
                  <TextInput
                    name="curp"
                    label="CURP"
                  />
                </Col>
              }
            </Div>
            <Div>
              <Button ghost onClick={() => this.props.closeModal()}>Cancelar</Button>
              <Button primary type="submit" loading={loading}>{this.getButtonTitle(type)}</Button>
            </Div>
          </Form>
          :
          <LoadingSpinner size={25} />
        }
      </Container>
    )
  }
}

ReinscriptionModal.propTypes = {
  /** Array of available classrooms in the center */
  classrooms: PropTypes.array.isRequired,
  /** Array of available contracts for the given parent */
  contracts: PropTypes.array,
  /** Array of companies registered on the platform */
  companies: PropTypes.array.isRequired,
  /** Array of contracts available for the selected company */
  company_contracts: PropTypes.array.isRequired,
  /** ID of the student being enrolled/reenrolled */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /** Array of parents belonging to the student being enrolled */
  parents: PropTypes.array.isRequired,
  /** The products (Daycare, 100 hours etc.) belonging to the center */
  products: PropTypes.array.isRequired,
  /** Array of study programs available at the center */
  studyPrograms: PropTypes.array.isRequired,
  /** Determine what type of enrollment is to be processed for the student */
  type: PropTypes.oneOf([
    'enroll',
    'reenroll',
    'reserved',
    'reenrollfromdisenroll',
  ]).isRequired,
  /** Loading flag */
  loading: PropTypes.bool.isRequired,

  needsCurp: PropTypes.bool,
  /** Array of payment types */
  payment_types: PropTypes.array.isRequired,
  /** Fetch all available contracts for the selected company from the API */
  getCompanyContracts: PropTypes.func.isRequired,
  /** Fetch all available contracts from the API */
  getParentContracts: PropTypes.func.isRequired,
  /** Fetch all payment types from the API */
  getPaymentTypes: PropTypes.func.isRequired,
  /** Attempt to enroll a given student for the first time */
  postEnroll: PropTypes.func.isRequired,
  /** Attempt to enroll a given student who has a reservation */
  postReserved: PropTypes.func.isRequired,
  /** Attempt to re-enroll a given student */
  postReEnroll: PropTypes.func.isRequired,
  /** Attempt to re-enroll a given student after they've been disenrolled */
  postReEnrollFromDisenrollments: PropTypes.func.isRequired,

  closeModal: PropTypes.func.isRequired,

  countries: PropTypes.array.isRequired,

  getCountries: PropTypes.func.isRequired,

  user: PropTypes.object,
}

ReinscriptionModal.defaultProps = {
  contracts: [],
  needsCurp: false,
  user: {},
}

const mapStateToProps = state => ({
  contracts: state.contracts.results,
  loadingcontracts: state.contracts.fetching,
  payment_types: state.payment_types.get.results,
  loading: state.enroll.sending.fetching || state.reserved.sending.fetching || state.reEnrollFromDisenrollments.sending.fetching,
  companies: state.companies.get.results,
  company_contracts: state.contracts.company_contracts.results,
  countries: state.countries.get.results,
  user: state.auth.user,
})

const mapDispatchToProps = dispatch => ({
  getPaymentTypes: () => dispatch(PaymentTypesActions.getRequest()),
  getCountries: () => dispatch(CountriesActions.getRequest()),
  getParentContracts: parentId => dispatch(ContractsActions.getContractsRequest(parentId)),
  getCompanyContracts: companyId =>
    dispatch(ContractsActions.getContractsByCompanyIdRequest(companyId)),
  postEnroll: (studentId, data) => dispatch(EnrollActions.enrollRequest(studentId, data)),
  postReserved: (studentId, data) => dispatch(ReservedActions.reservedRequest(studentId, data)),
  postReEnroll: (studentId, data) => dispatch(ReEnrollActions.reEnrollRequest(studentId, data)),
  postReEnrollFromDisenrollments: (studentId, data) =>
    dispatch(ReEnrollFromDisenrollmentsActions.reEnrollFromDisenrollmentsRequest(studentId, data)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReinscriptionModal))



// WEBPACK FOOTER //
// ./src/Containers/Inscriptions/ReinscriptionModal.jsx